module.exports = __webpack_public_path__ + "static/img/14areaB_3.997bbfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_3.png
// module id = 1126
// module chunks = 1